import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup, AbstractControl } from '@angular/forms';
import { NotificationService } from '../../../../shared/services/notifications.service';
import { ModalService } from '../../../../shared/modules/modal/modal.service';
import { CompSearchService } from '../../../../shared/services/comp-search.service';

import { ClosableModalWithErrorResponseModel } from 'src/app/shared/components/base/closable-modal-with-error-response-model';
import { LoadCompSearchPayload, CompSearchData, TuneCompSearchModalData } from '../../../../shared/models';

@Component({
  selector: 'load-comp-search-modal',
  templateUrl: './load-comp-search-modal.component.html',
  styleUrls: ['../tune-comparable-search.component.css']
})
export class LoadCompSearchModalComponent
  extends ClosableModalWithErrorResponseModel<any>
  implements OnInit {

  data: TuneCompSearchModalData;
  compSearches: CompSearchData[];
  loadCompSearchForm: FormGroup;
  confirmationInput: string;
  confirmationText: string;
  loadingCompSearch: boolean = false;

  constructor(
    protected notificationService: NotificationService,
    protected modalService: ModalService,
    private _compSearchService: CompSearchService,
    private _formBuilder: FormBuilder,
  ) {
    super(notificationService, modalService);
    this.confirmationInput = '';
    this.confirmationText = 'Fiona';
  }

  ngOnInit(): void {
    this.createForm();
    this.loadExistingCompSearches();
  }

  loadExistingCompSearches(): void {
    this._compSearchService.getSavedCompSearches(this.data.tenantId).subscribe(({ data }) => this.compSearches = data);
  }

  createForm() {
    this.loadCompSearchForm = this._formBuilder.group({
      compSearchName: ['', [Validators.required]],
      confirmation: ['', [Validators.required]]
    },
    {
      validator: this.IsValidConfirmationInput(this.confirmationText)
    });
  }

  IsValidConfirmationInput(confirmation: string): Function {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls.confirmation;
      control.value !== confirmation ? control.setErrors({ confirmation: true }) : control.setErrors(null);
    };
  }
 
  getCompSearchNameFormControl(): AbstractControl { return this.loadCompSearchForm.get('compSearchName'); }
  getConfirmationFormControl(): AbstractControl { return this.loadCompSearchForm.get('confirmation'); }

  validateFormAndLoad(): void {
    if (this.isValidForm()) {
      this.loadCompSearch();
    }
  }

  isValidForm(): boolean {
    return this.loadCompSearchForm.valid;
  }

  private loadCompSearch(): void {
    const selectedCompSearch: CompSearchData = this.getCompSearchNameFormControl().value;

    const payload: LoadCompSearchPayload = {
      loadCompSearchId: selectedCompSearch.compSearchId,
      compSearchName: selectedCompSearch.compSearchName,
      tenantId: this.data.tenantId,
      loadJurisdictionId: selectedCompSearch.jurisdictionId,
      loadContainerId: selectedCompSearch.containerId
    };

    const { compSearchId, jurisdictionId, containerId } = this.data;

    this.loadingCompSearch = true;
    this._compSearchService.loadCompSearch(payload, compSearchId, jurisdictionId, containerId).subscribe(() => {
      this.loadingCompSearch = false;
      this.success();
      this.closeAllModals();
    });
  }

  exitModal(): void {
    this.closeAllModals();
  }
}
